<template>
  <div :class="['activate-table-text-component', stylingClasses]">
    <span>{{ text }}</span>
  </div>
</template>

<script src="./table-column-text.js"></script>
